import React from 'react'
import NavBar from '../components/Home/NavBar'
import ConsentimientoUsuario from '../components/Forms/ConsentimientoBilateral/ConsentimientoUsuario'

const AnexoUsuario = () => {
  return (
    <div className='bg-gray-100 h-screen'>
      <NavBar />
      <div className='flex items-center justify-center p-12'>
        <ConsentimientoUsuario />
      </div>
    </div>
  )
}

export default AnexoUsuario